export const checkHistoryColumns = [
  {
    name: "index",
    label: "#",
    align: "center",
  },
  {
    name: "contractor_name",
    label: "Информация",
    align: "left",
  },
  {
    name: "is_accepted",
    label: "Статус",
    align: "center",
  },
  {
    name: "comments",
    label: "Замечание",
    align: "left",
  },
  {
    name: "file_urls",
    label: "Медиа-файлы",
    align: "center",
  },
];
